// Dependencies
import React from 'react';

// import { EVENT_TYPE, FORM_NAME } from '../../../../../lib/analytics-constants';
import { RentVsBuyInput } from '../../../../../lib/utils';
import { LEGACY_FIELD_NAMES } from '../../../analytics-constants';
import RentAppreciationInput from '../rent-appreciation';

const CONTROL_PANEL = 'controlPanel';

const analyticsPayload = {
  enabled: true,
  payload: {
    legacy: {
      formName: CONTROL_PANEL,
      fieldName: LEGACY_FIELD_NAMES.RENT_APPRECIATION,
    },
    // bedrock: {
    //   eventType: EVENT_TYPE.HOME_APPRECIATION_PERCENT_UPDATED,
    //   form_name: FORM_NAME.RENT_VS_BUY_CALCULATOR,
    //   was_prefilled: true,
    //   page_number: null,
    //   total_pages: null,
    //   additional_attributes: {
    //     housing_type: 'rent',
    //   },
    // },
  },
};
const RentAppreciationInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <RentAppreciationInput
      label={label}
      tooltip={tooltip}
      analytics={analyticsPayload}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default RentAppreciationInputWithAnalytics;
